// src/config/SessionConfig.js
export default {
  uuid: 'd81ade40-6cdc-499c-8d8d-b49626af774f', // replace with your own uuid, for example using https://www.uuidgenerator.net
  timeoutInMinutes: 300,
  cacheLocation: 'localStorage',
  debugMode: false // boolean to show or hide console log statements, useful while developing
};
